import { render, staticRenderFns } from "./VimeoCard.vue?vue&type=template&id=225c2805"
import script from "./VimeoCard.vue?vue&type=script&lang=js"
export * from "./VimeoCard.vue?vue&type=script&lang=js"
import style0 from "./VimeoCard.vue?vue&type=style&index=0&id=225c2805&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports